import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { App as AppWrapper, ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

// Store
import store from "./store";

// Helpers
import { ErrorFallbackPage, SiteLoader } from "./helpers/utils";
import ToastHandler from "./helpers/ToastHandler";

// Translation
import "./helpers/i18n";

// CSS Imports
import "./Assets/CSS/custom.css";
import "./Assets/CSS/style.css";
import "./Auth/CSS/style.css";
import "./Components/CSS/style.css";
import "./Components/CSS/style.scss";
import "./View/CSS/style.css";

// Swiper CSS
import "swiper/css";
import "swiper/css/navigation";

// Lazy-loaded Components
// Auth Pages
const AuthIndex = lazy(() => import("./Auth/AuthIndex"));
const Login = lazy(() => import("./Auth/Pages/Login"));

// View Pages
const Index = lazy(() => import("./View/Index"));
const ViewIndex = lazy(() => import("./View/ViewIndex"));
const Home = lazy(() => import("./View/Pages/Home"));
const Profile = lazy(() => import("./View/Pages/Profile"));
const PaymentSuccess = lazy(() => import("./View/Pages/Payment/Success"));
const PaymentFail = lazy(() => import("./View/Pages/Payment/Fail"));
const SignComplete = lazy(() => import("./View/Pages/SignComplete"));
const JoinTeam = lazy(() => import("./View/Pages/Payment/TMRWAcceptInvite"));

// Error Page
const PageNotFound = lazy(() => import("./Components/Pages/Error"));

// Constants
export const alias = process.env.REACT_APP_ALIAS || "";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "New Order",
          colorPrimary: "#3961e5",
        },
      }}
    >
      <AppWrapper>
        <Provider store={store}>
          <BrowserRouter basename={alias}>
            <Suspense fallback={<SiteLoader />}>
              <ErrorBoundary FallbackComponent={ErrorFallbackPage}>
                {/* Route List */}
                <Routes>
                  {/* Auth Routes */}
                  <Route path="/auth" element={<AuthIndex />}>
                    <Route path="login" element={<Login />} />
                  </Route>

                  {/* Public Routes */}
                  <Route path="/" element={<Index />}>
                    <Route index element={<Home />} />
                    <Route
                      path="accept-invite/:organizationId/:userId"
                      element={<JoinTeam />}
                    />
                  </Route>

                  {/* Protected/App Routes */}
                  <Route path="/" element={<ViewIndex />}>
                    <Route
                      path="payment/:id/success"
                      element={<PaymentSuccess />}
                    />
                    <Route path="payment/:id/fail" element={<PaymentFail />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="sign-success" element={<SignComplete />} />
                  </Route>

                  {/* Catch-all Route */}
                  <Route path="*" element={<PageNotFound />} />
                </Routes>
                {/* Route List End */}
              </ErrorBoundary>
            </Suspense>
          </BrowserRouter>
          <ToastHandler />
        </Provider>
      </AppWrapper>
    </ConfigProvider>
  </React.StrictMode>
);
